import React from 'react';
import PropTypes from 'prop-types';

function SectionNumber({ number }) {
  return (
    <div className="bg-light h5 py-2 mx-3 my-3 rounded text-center text-light">{number}</div>
  );
}
SectionNumber.propTypes = {
  number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
export default SectionNumber;
